import styles from "./styles.module.scss";
import cx from 'classnames';

interface InputGroupProps {
  label: string;
  value?: string;
  name?: string;
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errorMessage?: string;
  disabled?: boolean;
  type?: string;
}

const InputGroup = ({
  label,
  value,
  name,
  placeholder,
  type,
  onChange,
  errorMessage,
  disabled,
}: InputGroupProps) => {

  return (
    <div className={styles.container}>
      <label className={styles.label}> {label}</label>
      <input
        className={cx(styles.field, {[styles.errorField]: errorMessage})}
        type={ type ?? 'text'}
        value={value}
        name={name}
        placeholder={placeholder ?? 'enter here'}
        onChange={onChange}
        disabled={disabled}
      />
      {errorMessage && <p className={styles.error}>{errorMessage}</p>}
    </div>
  );
};

export default InputGroup;
